import { useCallback, useEffect, useState } from 'react';
import { fetchTripMemoryPreview, type TripMemoryPreview } from '@/services/tripMemories';

export function useTripMemoryPreview(tripId?: string, enabled: boolean = true) {
  const [preview, setPreview] = useState<TripMemoryPreview | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadPreview = useCallback(async () => {
    if (!tripId || !enabled) {
      setPreview(null);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const result = await fetchTripMemoryPreview(tripId);
      setPreview(result);
    } catch (err) {
      console.error('[useTripMemoryPreview] Failed to load memories', err);
      setError(err instanceof Error ? err.message : 'Unable to load memories');
    } finally {
      setLoading(false);
    }
  }, [tripId, enabled]);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      if (!isMounted) return;
      await loadPreview();
    })();
    return () => {
      isMounted = false;
    };
  }, [loadPreview]);

  return {
    preview,
    loading,
    error,
    refresh: loadPreview,
  };
}






